<!-- ftModal phase 2 / WS3: the NATIVE deferred-save bar + field-editor modal — used by EVERY
     branch now (no bridged fieldsEditor.compile remains; the bridge is fully drained from this
     component). [live]=panelLiveRoot (model.messaging for homepage, model.languageItems for the rest). -->
<ft-pending-changes-panel-ng #panel [live]="panelLiveRoot"
                             (save)="onPanelSave($event)" (cancelled)="onPanelCancel()" />
<ft-field-editor-modal [config]="fieldEditorConfig()" (closed)="fieldEditorConfig.set(null)" />

<!-- ftModal phase 2 / WS3: the homepage QuoteType + FixedQuoteProfileImage modals, native.
     Replaces the v1 \`<ft-modal id="dialogTypeModal"/"…imageLibraryModal" ft-snapshot=…>\` bridged
     compiles: the native \`ft-modal-overlay\` (CDK overlay at <body>) hosts the verbatim
     \`ft-modal-chrome-ng\` (default chrome = Save + X, footerCancel hidden — ftModal defaults)
     projecting native \`ft-select-ng\` / \`ft-image-library-ng\`. showHomepageModal() takes the
     ft-snapshot (model.messaging / model.languageItems) for the X/Cancel rollback. -->
<ft-modal-overlay [open]="homepageModal() === 'dialogTypeModal'">
  @if (homepageModal() === 'dialogTypeModal') {
    <ft-modal-chrome-ng
      [headerText]="'flipto.account.platform.homepage.touchpoints.QuoteType' | translate"
      size="sm"
      [doneVisible]="true"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onHomepageModalDone()"
      (cancel)="onHomepageModalCancel()"
    >
      <div class="modal-panel">
        <ft-select-ng [items]="model().dialogTypes"
          key="id"
          value="name"
          [(selectedKey)]="model().selectedDialogType.id"
          (change)="syncDialogType()"
         />
      </div>
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<ft-modal-overlay [open]="homepageModal() === 'imageLibraryModal'">
  @if (homepageModal() === 'imageLibraryModal') {
    <ft-modal-chrome-ng
      [headerText]="'flipto.account.platform.homepage.touchpoints.ProfileImage' | translate"
      size="sm"
      [doneVisible]="true"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onHomepageModalDone()"
      (cancel)="onHomepageModalCancel()"
    >
      <ft-image-library-ng [images]="model().propertyImages"
        [propertyId]="model().propertyId"
        [imageType]="1"
        view="list"
        (imageSelected)="updateFixedQuoteProfileImage($event)"
       />
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

@switch (touchpointType()) {

  <!-- WS4 inc 4-next: followup touchpoint (edit-followup-messages.html). Two
       ft-nav-pane screens (Follow-up Email + Share Page) toggled by [hidden]
       (the v1 ftScreen uses ng-show = display:none, NOT @if removal). -->
  @case ('followup') {
  <section class="ft-section ft-config-section has-sidenav">
      <div class="ft-container">
        <div class="ft-row">
          <div class="ft-col-25">
            <ul class="nav editor-nav">
              <li><a class="followup" style="display: inline-block;" (click)="screenName.set('followup')"
                     [class.active]="screenName() === 'followup'"
                     [innerHTML]="'flipto.account.platform.preStay.touchpoints.FollowupEmail' | translate"></a></li>
              <li><a class="share" style="display: inline-block;" (click)="screenName.set('share')"
                     [class.active]="screenName() === 'share'"
                     [innerHTML]="'flipto.account.platform.preStay.touchpoints.SharePage' | translate"></a></li>
            </ul>
          </div>
          <div class="ft-col-75">
            <div class="editor-preview followup">

              <!-- FOLLOW-UP EMAIL -->
              <ft-screen name="followup">
                <div [hidden]="screenName() !== 'followup'">
                  <div class="preview-chrome email">
                    <span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span>
                  </div>

                  <div class="preview-content">
                    <div class="preview-header limit-md">
                      <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
                      <div class="email-subject editable-content" ft-modal-fields-editor (click)="editFollowupSubject()">
                        <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['emailSubject'])"></div>
                      </div>
                      <hr />
                    </div>

                    <div class="preview-body limit-md">
                      @if (isFliptoStaff()) {
                        <div class="email-body editable-content" ft-modal-fields-editor (click)="editFollowupBody()">
                          <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['emailBody'])"></div>
                        </div>
                      } @else {
                        <div [innerHTML]="placeholderHtml(selectedData['emailBody'])"></div>
                      }

                      <div class="email-footer editable-content" ft-modal-fields-editor (click)="editFollowupFooter()">
                        <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['emailFooter'])"></div>
                      </div>

                      <div class="email-signature non-editable-content">&#123;property&#125;</div>
                    </div>
                  </div>

                  <div class="preview-options">
                    <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                             (selectedLanguageChange)="model().selectedLanguage = $event" />
                    <a class="launch-preview" (click)="sendFollowupEmailPreview()"
                       [class.disabled]="!getCurrentLanguage()?.demos?.signupCode"
                       [ftDisabled]="!getCurrentLanguage()?.demos?.signupCode"
                       [ftLaunchPreviewUnavailable]="!getCurrentLanguage()?.demos?.signupCode">
                      {{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i>
                    </a>
                  </div>
                </div>
              </ft-screen>

              <!-- SHARE PAGE -->
              <ft-screen name="share">
                <div [hidden]="screenName() !== 'share'">
                  <div class="preview-chrome browser"></div>

                  <div class="preview-content">
                    <div class="preview-body limit-md">
                      @if (isFliptoStaff()) {
                        <div class="share-prompt editable-content" ft-modal-fields-editor (click)="editFollowupSharePrompt()">
                          <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.ShareMessage' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['header'])"></div>
                        </div>
                      } @else {
                        <div [innerHTML]="placeholderHtml(selectedData['header'])"></div>
                      }

                      <div class="ft-row">
                        <div class="ft-col-66">
                          <div class="preview-pane non-editable-content">
                            &#123;advocate-share-message&#125;
                          </div>
                        </div>
                        <div class="ft-col-33">
                          <ul class="social-links list-unstyled non-editable-content">
                            <li><i class="fa fa-facebook-square"></i> Share on Facebook</li>
                            <li><i class="fa fa-twitter-square"></i> Post on X</li>
                            <li><i class="fa fa-linkedin-square"></i> Post on LinkedIn</li>
                          </ul>
                        </div>
                      </div>

                      <hr />

                      <div class="non-editable-content" [innerHTML]="placeholderHtml(selectedData['footer'])"></div>
                    </div>
                  </div>

                  <div class="preview-options">
                    <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                             (selectedLanguageChange)="model().selectedLanguage = $event" />
                    <a class="launch-preview" (click)="openFollowupLivePreview()"
                       [class.disabled]="!getCurrentLanguage()?.demos?.signupCode"
                       [ftDisabled]="!getCurrentLanguage()?.demos?.signupCode"
                       [ftLaunchPreviewUnavailable]="!getCurrentLanguage()?.demos?.signupCode">
                      {{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i>
                    </a>
                  </div>
                </div>
              </ft-screen>
            </div>
          </div>
        </div>
      </div>
  </section>
  }

  <!-- WS4 inc 6: FRIEND LANDING messaging (edit-landing-messages.html). Two ft-nav-pane
       screens (Sign-up + Sign-up with guest quote) editing landingHtml / landingQuoteHtml
       (html fields-editor). Reuses the ftNavPane→<ul class="nav editor-nav"> reproduction +
       ftScreen→[hidden] (the followup/reminder precedent). Reached via the inspiration1 card
       offramp; uses the prestay campaign data (no separate fetch). -->
  @case ('landing') {
  <section class="ft-section ft-config-section has-sidenav">
      <div class="ft-container">
        <div class="ft-row">
          <div class="ft-col-25">
            <ul class="nav editor-nav">
              <li><a class="signup" style="display: inline-block;" (click)="screenName.set('signup')"
                     [class.active]="screenName() === 'signup'"
                     [innerHTML]="('flipto.account.platform.preStay.touchpoints.SignUp' | translate | uppercase)"></a></li>
              <li><a class="signup-guest" style="display: inline-block;" (click)="screenName.set('signup-guest')"
                     [class.active]="screenName() === 'signup-guest'"
                     [innerHTML]="('flipto.account.platform.preStay.touchpoints.SignUpWithGuestQuote' | translate | uppercase)"></a></li>
            </ul>
          </div>
          <div class="ft-col-75">
            <div class="editor-preview prestay-landing-page">

              <ft-screen name="signup">
                <div [hidden]="screenName() !== 'signup'">
                  <div class="preview-chrome browser"></div>

                  <div class="preview-content">
                    <div class="preview-body limit-md">
                      <div class="preview-pane">
                        <div class="signup-message editable-content" ft-modal-fields-editor (click)="editLandingSignupMessage()">
                          <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.SignUpMessage' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['landingHtml'])"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="preview-options">
                    <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                             (selectedLanguageChange)="model().selectedLanguage = $event" />
                    <a class="launch-preview" (click)="openLandingSignUpLivePreview()"
                       [class.disabled]="!getCurrentLanguage()?.demos?.signupCode"
                       [ftDisabled]="!getCurrentLanguage()?.demos?.signupCode"
                       [ftLaunchPreviewUnavailable]="!getCurrentLanguage()?.demos?.signupCode">
                      {{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i>
                    </a>
                  </div>
                </div>
              </ft-screen>

              <ft-screen name="signup-guest">
                <div [hidden]="screenName() !== 'signup-guest'">
                  <div class="preview-chrome browser"></div>

                  <div class="preview-content">
                    <div class="preview-body limit-md">
                      <div class="preview-pane">
                        <div class="signup-message-quote editable-content" ft-modal-fields-editor (click)="editLandingGuestQuoteMessage()">
                          <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.SignUpWithGuestQuote' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['landingQuoteHtml'])"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="preview-options">
                    <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                             (selectedLanguageChange)="model().selectedLanguage = $event" />
                    <a class="launch-preview" (click)="openLandingSignUpGustLivePreview()"
                       [class.disabled]="!getCurrentLanguage()?.demos?.signupQuoteCode"
                       [ftDisabled]="!getCurrentLanguage()?.demos?.signupQuoteCode"
                       [ftLaunchPreviewUnavailable]="!getCurrentLanguage()?.demos?.signupQuoteCode">
                      {{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i>
                    </a>
                  </div>
                </div>
              </ft-screen>
            </div>
          </div>
        </div>
      </div>
  </section>
  }

  <!-- WS4 inc 6 grind: FRIEND LANDING (mobile) messaging (edit-mobile-messages.html). Two
       ft-nav-pane screens (Mobile page + Thank-you page) editing signupHeader/signupContent/
       signupInstructions (mobile) and thanksInstructions/thanksMessage (thankyou) — all text
       fields-editors. Disabled on quebec (the panel opens via the trigger regardless). -->
  @case ('mobile') {
  <section class="ft-section ft-config-section has-sidenav">
      <div class="ft-container">
        <div class="ft-row">
          <div class="ft-col-25">
            <ul class="nav editor-nav">
              <li><a class="mobile" style="display: inline-block;" (click)="screenName.set('mobile')"
                     [class.active]="screenName() === 'mobile'"
                     [innerHTML]="('flipto.account.platform.preStay.touchpoints.MobilePage' | translate)"></a></li>
              <li><a class="thankyou" style="display: inline-block;" (click)="screenName.set('thankyou')"
                     [class.active]="screenName() === 'thankyou'"
                     [innerHTML]="('flipto.account.platform.preStay.touchpoints.ThankYouPage' | translate)"></a></li>
            </ul>
          </div>
          <div class="ft-col-75">
            <div class="editor-preview mobile-landing-page">

              <ft-screen name="mobile">
                <div [hidden]="screenName() !== 'mobile'">
                  <div class="preview-chrome browser"></div>

                  <div class="preview-content">
                    <div class="preview-body limit-xs">
                      <div class="preview-profile-pic non-editable-content"><div class="preview-image-text">Guest photo</div></div>
                      <div class="signup-header editable-content" ft-modal-fields-editor (click)="editMobileSignupHeader()">
                        <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.GuestMessage' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['signupHeader'])"></div>
                      </div>
                      <div class="signup-content editable-content" ft-modal-fields-editor (click)="editMobileSignupContent()">
                        <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.IncentiveMessage' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['signupContent'])"></div>
                      </div>

                      <div class="preview-pane non-editable-content">
                        &#123;incentive&#125;
                      </div>

                      <div class="signup-instructions editable-content" ft-modal-fields-editor (click)="editMobileSignupInstructions()">
                        <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.RequestMessage' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['signupInstructions'])"></div>
                      </div>

                      <hr />

                      <div class="non-editable-content">
                        {{ 'flipto.account.platform.preStay.touchpoints.SignUpForm' | translate }}
                      </div>
                    </div>
                  </div>

                  <div class="preview-options">
                    <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                             (selectedLanguageChange)="model().selectedLanguage = $event" />
                    <a class="launch-preview" (click)="openMobileLandingLivePreview()"
                       [class.disabled]="!getCurrentLanguage()?.demos?.signupCode"
                       [ftDisabled]="!getCurrentLanguage()?.demos?.signupCode"
                       [ftLaunchPreviewUnavailable]="!getCurrentLanguage()?.demos?.signupCode">
                      {{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i>
                    </a>
                  </div>
                </div>
              </ft-screen>

              <ft-screen name="thankyou">
                <div [hidden]="screenName() !== 'thankyou'">
                  <div class="preview-chrome browser"></div>

                  <div class="preview-content">
                    <div class="preview-body limit-xs">
                      <div class="preview-pane">
                        <div class="preview-heading non-editable-content">{{ 'flipto.account.platform.preStay.touchpoints.Thanks' | translate }}!</div>
                        <div class="thanks-instructions editable-content" ft-modal-fields-editor (click)="editThanksInstructions()">
                          <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.ThanksInstructions' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['thanksInstructions'])"></div>
                        </div>
                        <div class="preview-profile-pic non-editable-content"><div class="preview-image-text">Guest photo</div></div>
                        <div class="thanks-message editable-content" ft-modal-fields-editor (click)="editThanksMessage()">
                          <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.RedirectMessage' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['thanksMessage'])"></div>
                        </div>
                        <div class="non-editable-content">
                          &#123;Property homepage&#125; →
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="preview-options">
                    <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                             (selectedLanguageChange)="model().selectedLanguage = $event" />
                  </div>
                </div>
              </ft-screen>
            </div>
          </div>
        </div>
      </div>
  </section>
  }

  <!-- WS4 inc 6 grind: HOMEPAGE-EMAIL "Redeem Email" messaging (edit-homepageEmail-messages.html).
       A clean single-screen email editor inside a .preview-panel (Subject/Body/Footer + property
       signature); field labels carry the ft-label visible-xs classes; launch-preview gated by
       canSendSampleEmail then sendRedeemEmailPreview. Empty fields show the ft-placeholder. -->
  @case ('homepageEmail') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="editor-preview">
        <div class="preview-panel">
          <div class="preview-chrome email">
            <span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span>
          </div>

          <div class="preview-content">
            <div class="preview-header limit-md">
              <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
              <div class="email-subject editable-content" ft-modal-fields-editor (click)="editHomepageEmailSubject()">
                <div class="ft-label visible-xs">{{ 'flipto.account.platform.Subject' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['emailSubject'])"></div>
              </div>
              <hr />
            </div>

            <div class="preview-body limit-md">
              <div class="email-body editable-content" ft-modal-fields-editor (click)="editHomepageEmailBody()">
                <div class="ft-label visible-xs">{{ 'flipto.account.platform.Body' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['emailBody'])"></div>
              </div>

              <div class="email-footer editable-content" ft-modal-fields-editor (click)="editHomepageEmailFooter()">
                <div class="ft-label visible-xs">{{ 'flipto.account.platform.Footer' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['emailFooter'])"></div>
              </div>

              <div class="email-signature non-editable-content">&#123;property&#125;</div>
            </div>
          </div>

          <div class="preview-options">
            <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                     (selectedLanguageChange)="model().selectedLanguage = $event" />
            <a class="launch-preview" [class.disabled]="!canSendSampleEmail()" [ftDisabled]="!canSendSampleEmail()" [ftLaunchPreviewUnavailable]="!canSendSampleEmail()" (click)="sendRedeemEmailPreview()">
              {{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind: PHOTO-RIVER "Story River" messaging (edit-photo-river-messages.html).
       Single-screen browser preview: Heading/Description/GalleryLinkMessage editable fields
       (required) + 2 empty preview-banner chunks + the photo-river live-preview. ft-direction
       -> [style.direction] (rtl/ltr per selected language; ltr default). Empty fields show the
       ft-placeholder. Standard MessagingController (model.languageItems snapshot + commit). -->
  @case ('photo-river') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="editor-preview photo-river">
        <div class="preview-chrome browser"></div>
        <div class="preview-content">
          <div class="preview-body limit-md">
            <div class="editable-content header-text" [style.direction]="textDirection()" ft-modal-fields-editor (click)="editPhotoRiverHeader()">
              <div class="ft-label">{{ 'flipto.account.Heading' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['header'])"></div>
            </div>
            <div class="editable-content subtitle-text" [style.direction]="textDirection()" ft-modal-fields-editor (click)="editPhotoRiverSubtitle()">
              <div class="ft-label">{{ 'flipto.account.Description' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['subtitle'])"></div>
            </div>
            <div class="chunk"><div class="preview-banner limit-md non-editable-content"></div></div>
            <div class="chunk"><div class="preview-banner limit-md non-editable-content"></div></div>
            <div class="chunk chunk-offramp">
              <div class="editable-content offramp-body" [style.direction]="textDirection()" ft-modal-fields-editor (click)="editPhotoRiverRampBody()">
                <div class="ft-label">{{ 'flipto.account.GalleryLinkMessage' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['ramp_body'])"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="preview-options">
          <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                   (selectedLanguageChange)="model().selectedLanguage = $event" />
          <a class="launch-preview" (click)="openPhotoRiverLivePreview()"
             [class.disabled]="!(getCurrentLanguage()?.code && getCurrentLanguage()?.fullCode)"
             [ftDisabled]="!(getCurrentLanguage()?.code && getCurrentLanguage()?.fullCode)"
             [ftLaunchPreviewUnavailable]="!(getCurrentLanguage()?.code && getCurrentLanguage()?.fullCode)">
            {{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind: HOMEPAGE "Homepage Component" messaging (edit-homepage-messages.html), the
       SPECIAL HomepageMessagingController. 2-screen nav-pane (Unlock / Sign-up). Unlock = preview
       (profile-pic + GuestQuote[parentQuoteHtml] + UnlockMessage[parentMessageHtml] + Unlock now!)
       + a ft-multi-panel (QuoteType[dialogTypeModal] / FixedQuoteProfileImage[imageLibraryModal,
       ng-show isUseFixedQuote] / FixedQuote[fixedQuoteText] / FixedQuoteName[fixedQuoteFirst+Last]).
       Sign-up = BookNowMessage[bookNowHtml] + SignupMessage[signupHtml]. Snapshot model.messaging +
       homepage commit (HomepageMixedData). -->
  @case ('homepage') {
  <section class="ft-section ft-config-section has-sidenav">
    <div class="ft-container">
      <div class="ft-row">
        <div class="ft-col-25">
          <ul class="nav editor-nav">
            <li><a class="unlock" style="display: inline-block;" (click)="screenName.set('unlock')"
                   [class.active]="screenName() === 'unlock'"
                   [innerHTML]="('flipto.account.platform.homepage.touchpoints.UnlockPanel' | translate | uppercase)"></a></li>
            <li><a class="signup" style="display: inline-block;" (click)="screenName.set('signup')"
                   [class.active]="screenName() === 'signup'"
                   [innerHTML]="('flipto.account.platform.homepage.touchpoints.SignUpPanel' | translate | uppercase)"></a></li>
          </ul>
        </div>
        <div class="ft-col-75">
          <ft-screen name="unlock">
            <div [hidden]="screenName() !== 'unlock'">
              <div class="editor-preview homepagecomponent-unlock">
                <div class="preview-panel">
                  <div class="preview-chrome browser"></div>
                  <div class="preview-content">
                    <div class="preview-pane">
                      <div class="preview-profile-pic non-editable-content"><div class="preview-image-text">Profile image</div></div>
                      <div class="guest-content editable-content" ft-modal-fields-editor (click)="editHomepageGuestQuote()">
                        <div class="ft-label visible-xs">{{ 'flipto.account.platform.homepage.touchpoints.GuestQuote' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['parentQuoteHtml'])"></div>
                      </div>
                      <hr />
                      <div class="ft-row">
                        <div class="ft-col-75">
                          <div class="editable-content" ft-modal-fields-editor (click)="editHomepageUnlockMessage()">
                            <div class="ft-label visible-xs">{{ 'flipto.account.platform.homepage.touchpoints.UnlockMessage' | translate }}:</div>
                            <div [innerHTML]="placeholderHtml(selectedData['parentMessageHtml'])"></div>
                          </div>
                        </div>
                        <div class="ft-col-25"><div class="preview-button non-editable-content">Unlock now!</div></div>
                      </div>
                    </div>
                  </div>
                  <div class="preview-options">
                    <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                             (selectedLanguageChange)="model().selectedLanguage = $event" />
                  </div>
                </div>
              </div>

              <div class="ft-multi-panel">
                <div class="ft-panel" ft-targets-modal="dialogTypeModal" (click)="showHomepageModal('dialogTypeModal')">
                  <div class="ft-row">
                    <div class="ft-col-33">
                      <div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.QuoteType' | translate }}:</div>
                      <div class="panel-summary">{{ 'flipto.account.platform.homepage.touchpoints.QuoteTypeSummary' | translate }}</div>
                    </div>
                    <div class="ft-col-66"><div>{{ dialogTypeName() }}</div></div>
                  </div>
                </div>
                <div class="ft-panel" ft-targets-modal="homepage-messages.imageLibraryModal"
                     [hidden]="!model().messaging?.isUseFixedQuote" (click)="showHomepageModal('homepage-messages.imageLibraryModal')">
                  <div class="ft-row">
                    <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.FixedQuoteProfileImage' | translate }}:</div></div>
                    <div class="ft-col-66">
                      <div class="thumbnail-image thumbnail-profile-pic" [ftBackgroundImage]="selectedData['fixedQuoteProfileImageUrl'] || ''">
                        <span class="placeholder" [hidden]="selectedData['fixedQuoteProfileImageUrl']">{{ 'flipto.account.AddAnImage' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ft-panel" ft-modal-fields-editor [hidden]="!model().messaging?.isUseFixedQuote" (click)="editHomepageFixedQuote()">
                  <div class="ft-row">
                    <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.FixedQuote' | translate }}:</div></div>
                    <div class="ft-col-66"><div [innerHTML]="placeholderHtml(selectedData['fixedQuoteText'])"></div></div>
                  </div>
                </div>
                <div class="ft-panel" ft-modal-fields-editor [hidden]="!model().messaging?.isUseFixedQuote" (click)="editHomepageFixedQuoteName()">
                  <div class="ft-row">
                    <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.FixedQuoteName' | translate }}:</div></div>
                    <div class="ft-col-66">
                      @if (!selectedData['fixedQuoteFirst'] && !selectedData['fixedQuoteLast']) {
                        <span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>
                      }
                      {{ (selectedData['fixedQuoteFirst'] || '') + (selectedData['fixedQuoteFirst'] && selectedData['fixedQuoteLast'] ? ' ' : '') + (selectedData['fixedQuoteLast'] || '') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ft-screen>

          <ft-screen name="signup">
            <div [hidden]="screenName() !== 'signup'">
              <div class="editor-preview homepagecomponent-signup">
                <div class="preview-panel">
                  <div class="preview-chrome browser"></div>
                  <div class="preview-content">
                    <div class="preview-pane">
                      <div class="ft-row">
                        <div class="ft-col-50">
                          <div class="booknow-message editable-content" ft-modal-fields-editor (click)="editHomepageBookNow()">
                            <div class="ft-label visible-xs">{{ 'flipto.account.platform.homepage.touchpoints.BookNowMessage' | translate }}:</div>
                            <div [innerHTML]="placeholderHtml(selectedData['bookNowHtml'])"></div>
                          </div>
                          <div class="preview-button non-editable-content">Book now</div>
                        </div>
                        <hr class="vertical" />
                        <div class="ft-col-50">
                          <div class="booklater-message editable-content" ft-modal-fields-editor (click)="editHomepageSignup()">
                            <div class="ft-label visible-xs">{{ 'flipto.account.platform.homepage.touchpoints.SignupMessage' | translate }}:</div>
                            <div [innerHTML]="placeholderHtml(selectedData['signupHtml'])"></div>
                          </div>
                          <div class="preview-button non-editable-content">Sign up</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="preview-options">
                    <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                             (selectedLanguageChange)="model().selectedLanguage = $event" />
                  </div>
                </div>
              </div>
            </div>
          </ft-screen>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 4-next: confirmation-email-image BANNER messaging
       (edit-confirmation-email-image-messages.html). Single editor-preview, email chrome,
       3 required edit panels (header/text/buttonText). No nav-pane, no staff-gate, no
       live-preview (commented out in v1). Snapshot model.languageItems → commit (shared). -->
  @case ('confirmation-email-image') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="editor-preview confirmation-email-image">

        <div class="preview-chrome email">
          <span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span>
        </div>

        <div class="preview-content">
          <div class="preview-body limit-md">
            <div class="preview-pane">
              <div class="editable-content banner-heading" ft-modal-fields-editor (click)="editBannerHeading()">
                <div class="ft-label">{{ 'flipto.account.platform.BannerHeading' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['header'])"></div>
              </div>
              <div class="editable-content banner-text" ft-modal-fields-editor (click)="editBannerText()">
                <div class="ft-label">{{ 'flipto.account.platform.BannerText' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['text'])"></div>
              </div>
              <div class="editable-content preview-button banner-button" ft-modal-fields-editor (click)="editBannerButtonText()">
                <div class="ft-label">{{ 'flipto.account.platform.BannerButtonText' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['buttonText'])"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="preview-options">
          <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                   (selectedLanguageChange)="model().selectedLanguage = $event" />
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind: post-stay INVITATION-EMAIL messaging (edit-invitation-email-messages.html).
       Single email editor-preview (Subject/Body/Footer) — no nav-pane, no staff-gate. The
       launch-preview sendPoststayEmailPreview SENDS a real email — never auto-triggered. -->
  @case ('invitation-email') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="editor-preview poststay-email">

        <div class="preview-chrome email">
          <span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span>
        </div>

        <div class="preview-content">
          <div class="preview-header limit-md">
            <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
            <div class="email-subject editable-content" ft-modal-fields-editor (click)="editInvitationSubject()">
              <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailSubject'])"></div>
            </div>
            <hr />
          </div>

          <div class="preview-body limit-md">
            <div class="email-body editable-content" ft-modal-fields-editor (click)="editInvitationBody()">
              <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailBody'])"></div>
            </div>

            <div class="email-footer editable-content" ft-modal-fields-editor (click)="editInvitationFooter()">
              <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailFooter'])"></div>
            </div>

            <div class="email-signature non-editable-content">&#123;property&#125;</div>
          </div>
        </div>

        <div class="preview-options">
          <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                   (selectedLanguageChange)="model().selectedLanguage = $event" />
          <a class="launch-preview" (click)="sendPoststayEmailPreview()">
            {{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind #6: photo-advocacy POSTSTAY-EMAIL-IMAGE banner messaging
       (edit-poststay-email-image-messages.html). ≈ confirmation-email-image (3 required banner
       panels header/text/buttonText) but on .editor-preview.poststay-email-image + an extra
       non-editable .preview-banner block (Contest name/dates/prizes). No live-preview (commented
       out in v1). Shares editBanner* (keyed by touchpointType). -->
  @case ('poststay-email-image') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="editor-preview poststay-email-image">

        <div class="preview-chrome email">
          <span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span>
        </div>

        <div class="preview-content">
          <div class="preview-body limit-md">
            <div class="preview-pane">
              <div class="editable-content banner-heading" ft-modal-fields-editor (click)="editBannerHeading()">
                <div class="ft-label">{{ 'flipto.account.platform.BannerHeading' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['header'])"></div>
              </div>
              <div class="editable-content banner-text" ft-modal-fields-editor (click)="editBannerText()">
                <div class="ft-label">{{ 'flipto.account.platform.BannerText' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['text'])"></div>
              </div>
              <div class="preview-banner limit-md non-editable-content">
                <div class="preview-heading">Contest name</div>
                Contest dates
                <br />
                <hr />
                Prizes
              </div>
              <div class="editable-content preview-button banner-button" ft-modal-fields-editor (click)="editBannerButtonText()">
                <div class="ft-label">{{ 'flipto.account.platform.BannerButtonText' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['buttonText'])"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="preview-options">
          <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                   (selectedLanguageChange)="model().selectedLanguage = $event" />
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind #7: photo-advocacy contest emails (FINALIST/REMINDER/ACTIVITY/WINNER) messaging.
       Single-screen email editors (Subject/Body/Footer + a per-type non-editable .preview-banner),
       shared editPhotoEmail* handlers (keyed by touchpointType), per-type preview method gated by
       canSendSampleEmail(). edit-{finalistsEmail,reminderEmail,activityEmail,winnerEmail}-messages.html. -->
  @case ('finalistsEmail') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="editor-preview photo-contest-finalist-email">
        <div class="preview-chrome email"><span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span></div>
        <div class="preview-content">
          <div class="preview-header limit-md ">
            <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
            <div class="email-subject editable-content" ft-modal-fields-editor (click)="editPhotoEmailSubject()">
              <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailSubject'])"></div>
            </div>
            <hr />
          </div>
          <div class="preview-banner limit-md non-editable-content">
            <div class="preview-heading">Contest name</div>
            <hr />
            X days remaining
            <br />
            Contest end date
            <br />
            Prizes
          </div>
          <div class="preview-body limit-md">
            <div class="email-body editable-content" ft-modal-fields-editor (click)="editPhotoEmailBody()">
              <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailBody'])"></div>
            </div>
            <div class="email-footer editable-content" ft-modal-fields-editor (click)="editPhotoEmailFooter()">
              <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailFooter'])"></div>
            </div>
            <div class="email-signature non-editable-content">&#123;property&#125;</div>
          </div>
        </div>
        <div class="preview-options">
          <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                   (selectedLanguageChange)="model().selectedLanguage = $event" />
          <a class="launch-preview" [class.disabled]="!canSendSampleEmail()" [ftDisabled]="!canSendSampleEmail()" [ftLaunchPreviewUnavailable]="!canSendSampleEmail()" (click)="sendFinalistEmailPreview()">
            {{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  }

  @case ('reminderEmail') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="editor-preview photo-contest-reminder-email">
        <div class="preview-chrome email"><span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span></div>
        <div class="preview-content">
          <div class="preview-header limit-md">
            <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
            <div class="email-subject editable-content" ft-modal-fields-editor (click)="editPhotoEmailSubject()">
              <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
              <span [innerHTML]="placeholderHtml(selectedData['emailSubject'])"></span>
            </div>
            <hr />
          </div>
          <div class="preview-banner limit-md non-editable-content">
            <div class="preview-heading">Contest name</div>
            <hr />
            X days remaining
            <br />
            Contest end date
            <br />
            Prizes
          </div>
          <div class="preview-body limit-md">
            <div class="email-body editable-content" ft-modal-fields-editor (click)="editPhotoEmailBody()">
              <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailBody'])"></div>
            </div>
            <div class="email-footer editable-content" ft-modal-fields-editor (click)="editPhotoEmailFooter()">
              <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailFooter'])"></div>
            </div>
            <div class="email-signature non-editable-content">&#123;property&#125;</div>
          </div>
        </div>
        <div class="preview-options">
          <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                   (selectedLanguageChange)="model().selectedLanguage = $event" />
          <a class="launch-preview" [class.disabled]="!canSendSampleEmail()" [ftDisabled]="!canSendSampleEmail()" [ftLaunchPreviewUnavailable]="!canSendSampleEmail()" (click)="sendReminderEmailPreview()">
            {{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  }

  @case ('activityEmail') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="editor-preview photo-contest-activity-email">
        <div class="preview-chrome email"><span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span></div>
        <div class="preview-content">
          <div class="preview-header limit-md">
            <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
            <div class="email-subject editable-content" ft-modal-fields-editor (click)="editPhotoEmailSubject()">
              <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailSubject'])"></div>
            </div>
            <hr />
          </div>
          <div class="preview-banner limit-md non-editable-content">
            Contest name
            <br />
            Ends in X days
            <div class="preview-pane limit-xs">
              You're currently
              <div class="preview-heading">Current place</div>
              <hr />
              Points
            </div>
          </div>
          <div class="preview-body limit-md">
            <div class="email-body editable-content" ft-modal-fields-editor (click)="editPhotoEmailBody()">
              <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailBody'])"></div>
            </div>
            <div class="email-footer editable-content" ft-modal-fields-editor (click)="editPhotoEmailFooter()">
              <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailFooter'])"></div>
            </div>
            <div class="email-signature non-editable-content">&#123;property&#125;</div>
          </div>
        </div>
        <div class="preview-options">
          <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                   (selectedLanguageChange)="model().selectedLanguage = $event" />
          <a class="launch-preview" [class.disabled]="!canSendSampleEmail()" [ftDisabled]="!canSendSampleEmail()" [ftLaunchPreviewUnavailable]="!canSendSampleEmail()" (click)="sendActivityEmailPreview()">
            {{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  }

  @case ('winnerEmail') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="editor-preview photo-contest-winner-email">
        <div class="preview-chrome email"><span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span></div>
        <div class="preview-content">
          <div class="preview-header limit-md">
            <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
            <div class="email-subject editable-content" ft-modal-fields-editor (click)="editPhotoEmailSubject()">
              <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailSubject'])"></div>
            </div>
            <hr />
          </div>
          <div class="preview-banner limit-md non-editable-content">
            Congrats &#123;first&#125;, you won!
            <div class="preview-pane limit-xs">
              <div class="preview-heading">Current place</div>
              <hr />
              Contest name
            </div>
          </div>
          <div class="preview-body limit-md">
            <div class="email-body editable-content" ft-modal-fields-editor (click)="editPhotoEmailBody()">
              <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailBody'])"></div>
            </div>
            <div class="email-footer editable-content" ft-modal-fields-editor (click)="editPhotoEmailFooter()">
              <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
              <div [innerHTML]="placeholderHtml(selectedData['emailFooter'])"></div>
            </div>
            <div class="email-signature non-editable-content">&#123;property&#125;</div>
          </div>
        </div>
        <div class="preview-options">
          <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                   (selectedLanguageChange)="model().selectedLanguage = $event" />
          <a class="launch-preview" [class.disabled]="!canSendSampleEmail()" [ftDisabled]="!canSendSampleEmail()" [ftLaunchPreviewUnavailable]="!canSendSampleEmail()" (click)="sendWinnerEmailPreview()">
            {{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind #3: post-stay REMINDER-EMAILS messaging (edit-reminder-emails-messages.html).
       An ft-alert tip + a 2-screen ft-nav-pane (non-view default / after-view) inside a
       .preview-panel; each screen is an email editor-preview (Subject/Body/Footer) + a launch
       preview (sendPoststay{NonView,AfterView}EmailPreview). The v1 ftScreen renders
       <div ng-show="screen.name===name"> (display:none) → mirrored with [hidden]. The 4 v1
       ft-screen blocks (2 content + 2 options) are kept verbatim so the rendered DOM matches. -->
  @case ('reminder-emails') {
    <div class="ft-alert-section">
      <div class="ft-alert">
        <div class="ft-alert-content">
          <p [innerHTML]="'flipto.account.ReminderEmailsTip' | translate"></p>
        </div>
      </div>
    </div>

    <section class="ft-section ft-config-section has-sidenav">
      <div class="ft-container">
        <div class="ft-row">
          <div class="ft-col-25">
            <ul class="nav editor-nav">
              <li><a class="non-view" style="display: inline-block;" (click)="screenName.set('non-view')"
                     [class.active]="screenName() === 'non-view'"
                     [innerHTML]="'flipto.account.ReminderNonViewTab' | translate"></a></li>
              <li><a class="after-view" style="display: inline-block;" (click)="screenName.set('after-view')"
                     [class.active]="screenName() === 'after-view'"
                     [innerHTML]="'flipto.account.ReminderAfterViewTab' | translate"></a></li>
            </ul>
          </div>

          <div class="ft-col-75">
            <div class="editor-preview poststay-email">
              <div class="preview-panel">
                <div class="preview-chrome email">
                  <span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span>
                </div>

                <!-- NON-VIEW content -->
                <ft-screen name="non-view">
                  <div [hidden]="screenName() !== 'non-view'">
                    <div class="preview-content">
                      <div class="preview-header limit-md">
                        <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
                        <div class="email-subject editable-content" ft-modal-fields-editor (click)="editReminderNonViewSubject()">
                          <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['nonViewEmailSubject'])"></div>
                        </div>
                        <hr />
                      </div>
                      <div class="preview-body limit-md">
                        <div class="email-body editable-content" ft-modal-fields-editor (click)="editReminderNonViewBody()">
                          <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['nonViewEmailBody'])"></div>
                        </div>
                        <div class="email-footer editable-content" ft-modal-fields-editor (click)="editReminderNonViewFooter()">
                          <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['nonViewEmailFooter'])"></div>
                        </div>
                        <div class="email-signature non-editable-content">&#123;property&#125;</div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <!-- AFTER-VIEW content -->
                <ft-screen name="after-view">
                  <div [hidden]="screenName() !== 'after-view'">
                    <div class="preview-content">
                      <div class="preview-header limit-md">
                        <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
                        <div class="email-subject editable-content" ft-modal-fields-editor (click)="editReminderAfterViewSubject()">
                          <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['afterViewEmailSubject'])"></div>
                        </div>
                        <hr />
                      </div>
                      <div class="preview-body limit-md">
                        <div class="email-body editable-content" ft-modal-fields-editor (click)="editReminderAfterViewBody()">
                          <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['afterViewEmailBody'])"></div>
                        </div>
                        <div class="email-footer editable-content" ft-modal-fields-editor (click)="editReminderAfterViewFooter()">
                          <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
                          <div [innerHTML]="placeholderHtml(selectedData['afterViewEmailFooter'])"></div>
                        </div>
                        <div class="email-signature non-editable-content">&#123;property&#125;</div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <!-- NON-VIEW preview-options -->
                <ft-screen name="non-view">
                  <div [hidden]="screenName() !== 'non-view'">
                    <div class="preview-options">
                      <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                               (selectedLanguageChange)="model().selectedLanguage = $event" />
                      <a class="launch-preview" (click)="sendPoststayNonViewEmailPreview()">{{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i></a>
                    </div>
                  </div>
                </ft-screen>

                <!-- AFTER-VIEW preview-options -->
                <ft-screen name="after-view">
                  <div [hidden]="screenName() !== 'after-view'">
                    <div class="preview-options">
                      <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                               (selectedLanguageChange)="model().selectedLanguage = $event" />
                      <a class="launch-preview" (click)="sendPoststayAfterViewEmailPreview()">{{ 'flipto.account.EmailSample' | translate }}&nbsp;<i class="fa fa-envelope-o"></i></a>
                    </div>
                  </div>
                </ft-screen>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  }

  <!-- WS4 inc 6 grind #5: post-stay REENGAGEMENT-EMAILS messaging (edit-reengagement-emails-messages.html).
       A 2-screen ft-nav-pane (no-quote default / no-photo) with a conditional rule warning + tip; each
       screen is an email editor-preview (Subject/Body/Footer). The language-selector is SHARED (outside
       the screens); only the launch-preview link toggles per screen (sendPoststayNo{Quote,Photo}EmailPreview). -->
  @case ('reengagement-emails') {
    <div class="ft-alert-section">
      <div class="ft-alert">
        <div class="ft-alert-content">
          @if (!reengagementPhotoExplorerActive) {
            <p class="ft-text-warning" [innerHTML]="'flipto.account.ReengagementEmailsRule' | translate"></p>
          }
          <p [innerHTML]="'flipto.account.ReengagementEmailsTip' | translate"></p>
        </div>
      </div>
    </div>

    <section class="ft-section ft-config-section has-sidenav">
      <div class="ft-container">
        <div class="ft-row">
          <div class="ft-col-25">
            <ul class="nav editor-nav">
              <li><a class="no-quote" style="display: inline-block;" (click)="screenName.set('no-quote')"
                     [class.active]="screenName() === 'no-quote'"
                     [innerHTML]="'flipto.account.ReengagementNoQuoteTab' | translate"></a></li>
              <li><a class="no-photo" style="display: inline-block;" (click)="screenName.set('no-photo')"
                     [class.active]="screenName() === 'no-photo'"
                     [innerHTML]="'flipto.account.ReengagementNoPhotoTab' | translate"></a></li>
            </ul>
          </div>

          <div class="ft-col-75">
            <div class="editor-preview poststay-email">
              <div class="preview-chrome email">
                <span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span>
              </div>

              <!-- NO-QUOTE content -->
              <ft-screen name="no-quote">
                <div [hidden]="screenName() !== 'no-quote'">
                  <div class="preview-content">
                    <div class="preview-header limit-md">
                      <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
                      <div class="email-subject editable-content" ft-modal-fields-editor (click)="editReengagementNoQuoteSubject()">
                        <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['noQuoteEmailSubject'])"></div>
                      </div>
                      <hr />
                    </div>
                    <div class="preview-body limit-md">
                      <div class="email-body editable-content" ft-modal-fields-editor (click)="editReengagementNoQuoteBody()">
                        <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['noQuoteEmailBody'])"></div>
                      </div>
                      <div class="email-footer editable-content" ft-modal-fields-editor (click)="editReengagementNoQuoteFooter()">
                        <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['noQuoteEmailFooter'])"></div>
                      </div>
                      <div class="email-signature non-editable-content">&#123;property&#125;</div>
                    </div>
                  </div>
                </div>
              </ft-screen>

              <!-- NO-PHOTO content -->
              <ft-screen name="no-photo">
                <div [hidden]="screenName() !== 'no-photo'">
                  <div class="preview-content">
                    <div class="preview-header limit-md">
                      <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
                      <div class="email-subject editable-content" ft-modal-fields-editor (click)="editReengagementNoPhotoSubject()">
                        <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['noPhotoEmailSubject'])"></div>
                      </div>
                      <hr />
                    </div>
                    <div class="preview-body limit-md">
                      <div class="email-body editable-content" ft-modal-fields-editor (click)="editReengagementNoPhotoBody()">
                        <div class="ft-label">{{ 'flipto.account.platform.Body' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['noPhotoEmailBody'])"></div>
                      </div>
                      <div class="email-footer editable-content" ft-modal-fields-editor (click)="editReengagementNoPhotoFooter()">
                        <div class="ft-label">{{ 'flipto.account.platform.Footer' | translate }}:</div>
                        <div [innerHTML]="placeholderHtml(selectedData['noPhotoEmailFooter'])"></div>
                      </div>
                      <div class="email-signature non-editable-content">&#123;property&#125;</div>
                    </div>
                  </div>
                </div>
              </ft-screen>

              <div class="preview-options">
                <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                         (selectedLanguageChange)="model().selectedLanguage = $event" />
                <ft-screen name="no-quote">
                  <div [hidden]="screenName() !== 'no-quote'">
                    <a class="launch-preview" (click)="sendPoststayNoQuoteEmailPreview()">{{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i></a>
                  </div>
                </ft-screen>
                <ft-screen name="no-photo">
                  <div [hidden]="screenName() !== 'no-photo'">
                    <a class="launch-preview" (click)="sendPoststayNoPhotoEmailPreview()">{{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i></a>
                  </div>
                </ft-screen>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  }

  @default {
  <section class="ft-section ft-config-section">
      <div class="ft-container">
        <div class="editor-preview confirmation">

          <div class="preview-chrome browser"></div>

          <div class="preview-content">

            <div class="preview-header limit-md">
              <div class="confirmation-message editable-content" ft-modal-fields-editor (click)="editConfirmationMessage()">
                <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.ConfirmationMessage' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['topReservationComplete'])"></div>
              </div>
              <a class="confirmation-link editable-content" ft-modal-fields-editor (click)="editConfirmationLink()">
                <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.ConfirmationLink' | translate }}:</div>
                <div [innerHTML]="placeholderHtml(selectedData['topHideConfirmation'])"></div>
              </a>
            </div>

            <div class="preview-body limit-md">
              <div class="preview-pane">
                <div class="share-prompt editable-content" ft-modal-fields-editor (click)="editSharePrompt()">
                  <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.ShareMessage' | translate }}:</div>
                  <div [innerHTML]="placeholderHtml(selectedData['header'])"></div>
                </div>

                <div class="ft-row">
                  <div class="ft-col-66">
                    <div class="preview-pane non-editable-content">
                      &#123;advocate-share-message&#125;
                    </div>
                  </div>
                  <div class="ft-col-33">
                    <ul class="social-links list-unstyled non-editable-content">
                      <li><i class="fa fa-facebook-square"></i> Share on Facebook</li>
                      <li><i class="fa fa-twitter-square"></i> Post on X</li>
                      <li><i class="fa fa-linkedin-square"></i> Post on LinkedIn</li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div class="preview-options">
            <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                     (selectedLanguageChange)="model().selectedLanguage = $event" />
            <a class="launch-preview" (click)="openConfirmationLivePreview()"
               [class.disabled]="!(getCurrentLanguage()?.code && getCurrentLanguage()?.fullCode)"
               [ftDisabled]="!(getCurrentLanguage()?.code && getCurrentLanguage()?.fullCode)"
               [ftLaunchPreviewUnavailable]="!(getCurrentLanguage()?.code && getCurrentLanguage()?.fullCode)">
              {{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i>
            </a>
          </div>
        </div>

      </div>
    </section>
  }

  <!-- WS4 inc 6 grind (LAST touchpoint editor): quote "Post-stay Process" messaging
       (messaging-version.html → ng-include edit-quote-messages-v2.html, the ACTIVE v2).
       The version chrome is reproduced verbatim: <ft-version-panel> renders EMPTY on quebec
       (panel.visible false — activatedVersion == availableVersion, no newer version; baseline-probed);
       the inert <ft-sheet-tabs> renders an empty .sheet-tabs>ul (sheetTabs undefined — the real
       Messaging/Styling/Integration nav is the adapter's <ft-sections>, contest-sheets precedent);
       the content lives in .sheet-body (the <ft-pending-changes-panel> is bridged into
       #pendingChangesHost above with the v1 dual-version snapshot). The 10 ft-screen sections are the
       same ftNavPane + [hidden] pattern as followup; each editable-content opens the bridged
       ftModalFieldsEditor (model.languageItems). -->
  @case ('quote') {
    <ft-version-panel />
    <!-- Wrapped in the inert inline <ft-sheet-tabs> like v1 (and the contest sheets): a bare
         block div lets the empty <ul>'s 16px UA margin collapse up and shift the sheet down. -->
    <ft-sheet-tabs state-array="sheetTabs"><div class="sheet-tabs"><ul></ul></div></ft-sheet-tabs>
    <div class="sheet-body">
      <section class="ft-section ft-config-section has-sidenav">
        <div class="ft-container">
          <div class="ft-row">
            <div class="ft-col-25">
              <ul class="nav editor-nav">
                <li><a class="intro" style="display: inline-block;" (click)="screenName.set('intro')" [class.active]="screenName() === 'intro'" [innerHTML]="'flipto.account.Intro' | translate"></a></li>
                <li><a class="poststayrating" style="display: inline-block;" (click)="screenName.set('poststayrating')" [class.active]="screenName() === 'poststayrating'" [innerHTML]="'flipto.account.Rating' | translate"></a></li>
                <li><a class="quoteFeedback" style="display: inline-block;" (click)="screenName.set('quoteFeedback')" [class.active]="screenName() === 'quoteFeedback'" [innerHTML]="'flipto.account.QuoteFeedback' | translate"></a></li>
                @if (model().isPhotoAdvocacyEnabled) {
                  <li><a class="contest" style="display: inline-block;" (click)="screenName.set('contest')" [class.active]="screenName() === 'contest'" [innerHTML]="'flipto.account.Contest' | translate"></a></li>
                }
                <li><a class="share" style="display: inline-block;" (click)="screenName.set('share')" [class.active]="screenName() === 'share'" [innerHTML]="'flipto.account.Share' | translate"></a></li>
                <li><a class="thanks" style="display: inline-block;" (click)="screenName.set('thanks')" [class.active]="screenName() === 'thanks'" [innerHTML]="'flipto.account.Thanks' | translate"></a></li>
                <li><span class="ft-label">{{ 'flipto.account.platform.postStay.touchpoints.IfGuestGaveALowRating' | translate }}</span></li>
                <li><a class="feedbackLowRating" style="display: inline-block;" (click)="screenName.set('feedbackLowRating')" [class.active]="screenName() === 'feedbackLowRating'" [innerHTML]="'flipto.account.platform.postStay.touchpoints.FeedbackLowRating' | translate"></a></li>
                <li><a class="thanksLowRating" style="display: inline-block;" (click)="screenName.set('thanksLowRating')" [class.active]="screenName() === 'thanksLowRating'" [innerHTML]="'flipto.account.platform.postStay.touchpoints.ThanksLowRating' | translate"></a></li>
                <li><span class="ft-label">{{ 'flipto.account.IfGuestRatedFromEmail' | translate }}</span></li>
                <li><a class="introFromEmail" style="display: inline-block;" (click)="screenName.set('introFromEmail')" [class.active]="screenName() === 'introFromEmail'" [innerHTML]="'flipto.account.IntroHighRating' | translate"></a></li>
                <li><a class="introFromEmailLowRating" style="display: inline-block;" (click)="screenName.set('introFromEmailLowRating')" [class.active]="screenName() === 'introFromEmailLowRating'" [innerHTML]="'flipto.account.IntroLowRating' | translate"></a></li>
              </ul>
            </div>
            <div class="ft-col-75">
              <div class="editor-preview poststay-v2">
                <div class="preview-chrome browser"></div>

                <ft-screen name="intro">
                  <div [hidden]="screenName() !== 'intro'">
                    <div class="preview-content preview-content-intro">
                      <div class="preview-body limit-md">
                        <div class="preview-heading limit-xs non-editable-content">{{ 'flipto.account.HiFirst' | translate }}</div>
                        <div class="editable-content limit-xs" ft-modal-fields-editor (click)="editIntroCaption()">
                          <div class="ft-label">{{ 'flipto.account.IntroMessage' | translate }}</div>
                          <div [innerHTML]="placeholderHtml(selectedData['introCaption'])"></div>
                        </div>
                        <div class="preview-progress non-editable-content">{{ 'flipto.account.ProgressMeter' | translate }}</div>
                        <div class="preview-button non-editable-content">{{ 'flipto.account.GetStarted' | translate }}</div>
                        <div>
                          <div class="preview-section-heading non-editable-content">{{ 'flipto.account.JoinOurPhotoContest' | translate }}</div>
                          <div class="editable-content limit-xs" ft-modal-fields-editor (click)="editIntroContestCaption()">
                            <div class="ft-label">{{ 'flipto.account.ContestDetails' | translate }}</div>
                            <div [innerHTML]="placeholderHtml(selectedData['introContestCaption'])"></div>
                          </div>
                          <div class="preview-section-heading non-editable-content">
                            <div class="ft-label">{{ 'flipto.account.RewardsDetailsTitle' | translate }}</div>
                            {{ 'flipto.account.PickRewards' | translate }}
                          </div>
                          <div class="editable-content limit-xs" ft-modal-fields-editor (click)="editIntroRewardsCaption()">
                            <div class="ft-label">{{ 'flipto.account.RewardsDetails' | translate }}</div>
                            <div [innerHTML]="placeholderHtml(selectedData['introRewardsCaption'])"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <ft-screen name="poststayrating">
                  <div [hidden]="screenName() !== 'poststayrating'">
                    <div class="preview-content preview-content-rating">
                      <div class="preview-body limit-xs">
                        <div class="non-editable-content">{{ 'flipto.account.HowLikelyAreYouToRecommendUsToFriends' | translate }}</div>
                      </div>
                      <ul class="ratings list-unstyled non-editable-content">
                        <li class="count">0</li>
                        <li class="count">1</li>
                        <li class="count">2</li>
                        <li class="count">3</li>
                        <li class="count">4</li>
                        <li class="count">5</li>
                      </ul>
                      <div class="ratings-caption">
                        <div class="ratings-caption-low non-editable-content">{{ 'flipto.account.NoWay' | translate }}</div>
                        <div class="ratings-caption-high non-editable-content">{{ 'flipto.account.AbsolutelyWill' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                @if (model().isPhotoAdvocacyEnabled) {
                <ft-screen name="contest">
                  <div [hidden]="screenName() !== 'contest'">
                    <div class="preview-content preview-content-contest">
                      <div class="preview-body limit-sm">
                        <div class="non-editable-content">{{ 'flipto.account.ContestTitleTheme' | translate }}<br />{{ 'flipto.account.WinnerPlacesAndPrizes' | translate }}</div>
                        <div class="preview-pane">
                          <div class="preview-heading non-editable-content">{{ 'flipto.account.JoinOurPhotoContest' | translate }}!</div>
                          <div class="editable-content" ft-modal-fields-editor (click)="editContestCaption()">
                            <div class="ft-label">{{ 'flipto.account.JoinContestMessage' | translate }}</div>
                            <div [innerHTML]="placeholderHtml(selectedData['contestCaption'])"></div>
                          </div>
                          <div class="preview-pane preview-dropbox non-editable-content">
                            <div class="preview-dropbox-icon "></div>
                            <div class="preview-upload-text">{{ 'flipto.account.AddYourWinningPhotoHere' | translate }}</div>
                          </div>
                          <div class="non-editable-content">{{ 'flipto.account.ClickBelowToGrabItFromSomewhereElse' | translate }}
                            <div class="social-links">
                              <span><i class="fa fa-facebook"></i></span>
                              <span><i class="fa fa-instagram"></i></span>
                            </div>
                          </div>
                        </div>
                        <div class="preview-text-link non-editable-content">  {{ 'flipto.account.OrSkipTheContest' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </ft-screen>
                }

                <ft-screen name="quoteFeedback">
                  <div [hidden]="screenName() !== 'quoteFeedback'">
                    <div class="preview-content preview-content-quote">
                      <div class="preview-body limit-xs">
                        <!-- v1 (edit-quote-messages-v2.html) ft-disabled="!identity.isFliptoStaff()" —
                             the ONLY quote editor staff-locked; no 'disabled' class in v1 either. -->
                        <div class="editable-content" ft-modal-fields-editor [ftDisabled]="!isFliptoStaff()" (click)="editQuotePositiveNotes()">
                          <div class="ft-label">{{ 'flipto.account.QuoteMessage' | translate }}</div>
                          <div [innerHTML]="placeholderHtml(selectedData['quotePositiveNotesLabel'])"></div>
                        </div>
                        <div class="preview-input"></div>
                        @if (parseBool(model().messaging?.isRequestPlaceForQuoteEnabled) && isFliptoStaff()) {
                          <div>
                            <div class="editable-content" ft-modal-fields-editor (click)="editQuotePlaceSelection()">
                              <div class="ft-label">Place message</div>
                              <div [innerHTML]="placeholderHtmlText(selectedData['quotePlaceSelectionLabel'], 'Is there any specific place related to this memory?')"></div>
                            </div>
                            <div class="preview-input"></div>
                          </div>
                        }
                        <div class="editable-content" ft-modal-fields-editor (click)="editQuotePositiveOptional()">
                          <div class="ft-label">{{ 'flipto.account.FeedbackMessage' | translate }}</div>
                          <div [innerHTML]="placeholderHtml(selectedData['quotePositiveOptionalLabel'])"></div>
                        </div>
                        <div class="preview-input"></div>
                        <div class="preview-button non-editable-content">{{ 'flipto.account.Submit' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <ft-screen name="share">
                  <div [hidden]="screenName() !== 'share'">
                    <div class="preview-content preview-content-share">
                      <div class="preview-body limit-sm">
                        <div class="editable-content limit-xs" ft-modal-fields-editor (click)="editShareCaption()">
                          <div class="ft-label"> {{ 'flipto.account.ShareMessage' | translate }}</div>
                          <div [innerHTML]="placeholderHtml(selectedData['shareCaption'])"></div>
                        </div>
                        <div class="preview-pane share-message">
                          <div class="editable-content" ft-modal-fields-editor (click)="editShareMessage()">
                            <div class="ft-label"> {{ 'flipto.account.ShareQuote' | translate }}</div>
                            <div [innerHTML]="placeholderHtml(selectedData['shareMessage'])"></div>
                          </div>
                        </div>
                        <ul class="share-options list-unstyled non-editable-content">
                          <li><i class="fa fa-facebook"></i></li>
                          <li><i class="fa fa-twitter"></i></li>
                          <li><i class="fa fa-linkedin"></i></li>
                        </ul>
                        <div class="preview-text-link non-editable-content">{{ 'flipto.account.SkipSharing' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <ft-screen name="thanks">
                  <div [hidden]="screenName() !== 'thanks'">
                    <div class="preview-content preview-content-thanks">
                      <div class="preview-body limit-sm">
                        <div class="preview-heading limit-xs non-editable-content">{{ 'flipto.account.Thanks' | translate }}!</div>
                        <div class="editable-content limit-xs" ft-modal-fields-editor (click)="editThanksCaptionPositive()">
                          <div class="ft-label"> {{ 'flipto.account.ThanksMessage' | translate }}</div>
                          <div [innerHTML]="placeholderHtml(selectedData['thanksCaptionPositive'])"></div>
                        </div>
                        <div class="preview-pane">
                          <div class="editable-content" ft-modal-fields-editor (click)="editThanksExternalLink()">
                            <div class="ft-label"> {{ 'flipto.account.ExternalReviewMessage' | translate }}</div>
                            <div [innerHTML]="placeholderHtml(selectedData['thanksExternalLinkLabel'])"></div>
                          </div>
                          <div class="preview-button non-editable-content">{{ 'flipto.account.LetsGo' | translate }} →</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <ft-screen name="feedbackLowRating">
                  <div [hidden]="screenName() !== 'feedbackLowRating'">
                    <div class="preview-content preview-content-feedbackLowRating">
                      <div class="preview-body limit-xs">
                        <div class="editable-content" ft-modal-fields-editor (click)="editQuoteNegativeNotes()">
                          <div class="ft-label">{{ 'flipto.account.FeedbackMessage' | translate }}</div>
                          <div [innerHTML]="placeholderHtml(selectedData['quoteNegativeNotesLabel'])"></div>
                        </div>
                        <div class="preview-input"></div>
                        <div class="preview-button non-editable-content">{{ 'flipto.account.Submit' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <ft-screen name="thanksLowRating">
                  <div [hidden]="screenName() !== 'thanksLowRating'">
                    <div class="preview-content preview-content-thanksLowRating">
                      <div class="preview-body limit-xs">
                        <div class="preview-heading limit-xs non-editable-content">{{ 'flipto.account.Thanks' | translate }}!</div>
                        <div class="editable-content limit-xs" ft-modal-fields-editor (click)="editThanksCaptionNegative()">
                          <div class="ft-label">{{ 'flipto.account.ThanksMessage' | translate }}</div>
                          <div [innerHTML]="placeholderHtml(selectedData['thanksCaptionNegative'])"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <ft-screen name="introFromEmail">
                  <div [hidden]="screenName() !== 'introFromEmail'">
                    <div class="preview-content preview-content-introFromEmail">
                      <div class="preview-body limit-md">
                        <div class="preview-heading limit-xs non-editable-content">{{ 'flipto.account.ThanksFirst' | translate }}!</div>
                        <div class="editable-content limit-xs" ft-modal-fields-editor (click)="editIntroCaptionPositiveRating()">
                          <div class="ft-label">{{ 'flipto.account.IntroMessage' | translate }}</div>
                          <div [innerHTML]="placeholderHtml(selectedData['introCaptionPositiveRating'])"></div>
                        </div>
                        <div class="preview-progress non-editable-content">{{ 'flipto.account.ProgressMeter' | translate }}</div>
                        <div class="preview-button non-editable-content">{{ 'flipto.account.KeepOnGoing' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <ft-screen name="introFromEmailLowRating">
                  <div [hidden]="screenName() !== 'introFromEmailLowRating'">
                    <div class="preview-content preview-content-introFromEmailLowRating">
                      <div class="preview-body limit-md">
                        <div class="preview-heading limit-xs non-editable-content">{{ 'flipto.account.ThanksFirst' | translate }}!</div>
                        <div class="editable-content limit-xs" ft-modal-fields-editor (click)="editIntroCaptionNegativeRating()">
                          <div class="ft-label">{{ 'flipto.account.IntroMessage' | translate }}</div>
                          <div>
                            <div [innerHTML]="placeholderHtml(selectedData['introCaptionNegativeRating'])"></div>
                          </div>
                        </div>
                        <div class="preview-progress non-editable-content">{{ 'flipto.account.ProgressMeter' | translate }}</div>
                        <div class="preview-button non-editable-content">{{ 'flipto.account.KeepOnGoing' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </ft-screen>

                <div class="preview-options">
                  <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                           (selectedLanguageChange)="model().selectedLanguage = $event" />
                  <a class="launch-preview" (click)="openPoststayPreview()">{{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i> </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  }

}
